const AccountingAppletPermissions = {

    sections: {

        admin: {
            key: 'admin',
            title: '{{lang}}admin',
            hasExtraHeaders: false,
            headers: {
                view: { key: 'view', title: '{{lang}}view', main: true },
                create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                go: { key: 'go', title: '{{lang}}goStage', dependancy: 'view', main: true },
                delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                self: { key: 'self', title: '{{lang}}محدود به شخص', dependancy: 'view', main: true,reverse:true },
                // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
            },

            permissions: {

                forms: {
                    key: 'forms',
                    title: '{{lang}}customer form',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                        self: { key: 'self', title: '{{lang}}محدود به شخص', dependancy: 'view', main: true,reverse:true },

                        // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                        // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
                    }
                },

                contracts: {
                    key: 'contracts',
                    title: '{{lang}}customer contracts',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                        self: { key: 'self', title: '{{lang}}محدود به شخص', dependancy: 'view', main: true,reverse:true },

                        // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                        // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
                    }
                },
                currentStatus: {
                    key: 'currentStatus',
                    title: '{{lang}}current status',
                    headers: {
                        edit: { key: 'edit', title: '{{lang}}editStage', main: true },
                        go: { key: 'go', title: '{{lang}}goStage', main: true },

                        // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                        // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
                    }
                },
                financials: {
                    key: 'financials',
                    title: '{{lang}}financials confirmation',
                    headers: {
                        edit: { key: 'edit', title: '{{lang}}edit', main: true },
                        self: { key: 'self', title: '{{lang}}محدود به شخص', main: true,reverse:true },


                        // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                        // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
                    }
                },

                // leadsreport: {
                //     key: 'leadsreport',
                //     title: '{{lang}}گزارش کلی لیدها',
                //     headers: {
                //         view: { key: 'view', title: '{{lang}}view', main: true },
                //         // create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                //         // edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                //         // delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                //     }
                // },

                // leadsstatus: {
                //     key: 'leadsstatus',
                //     title: '{{lang}}وضعیت لیدها',
                //     headers: {
                //         view: { key: 'view', title: '{{lang}}view', main: true },
                //         // create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                //         // edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                //         // delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                //     }
                // },

                // hotleads: {
                //     key: 'hotleads',
                //     title: '{{lang}}میزان پیش ثبت نام قطعی',
                //     headers: {
                //         view: { key: 'view', title: '{{lang}}view', main: true },
                //         // create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                //         // edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                //         // delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                //     }
                // },



                permissions: {

                    key: 'permissions',
                    title: 'دسترسی‌های شعبه',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


            }
        },

        settings: {
            key: 'settings',
            title: '{{lang}}settings',
            hasExtraHeaders: false,
            headers: {
                view: { key: 'view', title: '{{lang}}view', main: true },
                create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
            },

            permissions: {


                users: {
                    key: 'users',
                    title: '{{lang}}Users management',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },

                veterinarians: {
                    key: 'veterinarians',
                    title: '{{lang}}Veterinarians Management',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },

                horseBreeders: {
                    key: 'horseBreeders',
                    title: '{{lang}}Horse Breeders Management',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },
                AutoGens: {
                    key: 'AutoGens',
                    title: '{{lang}}Auto Gens Management',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                permissions: {

                    key: 'permissions',
                    title: '{{lang}}permissions',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                branches: {
                    key: 'branches',
                    title: '{{lang}}Branches management',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                colors: {
                    key: 'colors',
                    title: '{{lang}}مدیریت رنگ‌ها',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                horses: {
                    key: 'horses',
                    title: '{{lang}}مدیریت نژاد ها',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },
                countries: {
                    key: 'countries',
                    title: '{{lang}}مدیریت کشور ها',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                // adminLogs: {
                //     key: 'adminLogs',
                //     title: '{{lang}}Admin Logs',
                //     headers: {
                //         view: { key: 'view', title: '{{lang}}view', main: true },
                //     }
                // },

                // settings: {
                //     key: 'settings',
                //     title: '{{lang}}settings',
                //     headers: {
                //         view: { key: 'view', title: '{{lang}}view', main: true },
                //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                //     }
                // },
            }
        }

    }

}


export { AccountingAppletPermissions }